<!-- guests -->
<div class="card border-0 guest-picker">
    <div class="card-body">
        <h5 class="card-title">* Select Your Guests</h5>
        <div class="card-text guest-picker-list">
            <div class="guest-picker-row">
                <div class="guest-picker-info">
                    <span class="badge bg-secondary text-lg">{{ guests.adults }}</span>
                    <span>Adults</span>
                </div>
                <div class="guest-picker-actions">
                    <button class="btn btn-outline-primary rounded-circle guest-picker-btn" type="button"
                        (click)="incrementGuests('adults', -1)">
                        <i class="fa-solid fa-minus"></i>
                    </button>
                    <button class="btn btn-outline-primary rounded-circle guest-picker-btn" type="button"
                        (click)="incrementGuests('adults', 1)">
                        <i class="fa-solid fa-plus"></i>
                    </button>
                </div>
            </div>
            <div class="tol-divider"></div>
            <div class="guest-picker-row">
                <div class="guest-picker-info">
                    <span class="badge bg-secondary text-lg">{{ guests.children }}</span>
                    <span>Children</span>
                </div>
                <div class="guest-picker-actions">
                    <button class="btn btn-outline-primary rounded-circle guest-picker-btn" type="button"
                        (click)="incrementGuests('children', -1)">
                        <i class="fa-solid fa-minus"></i>
                    </button>
                    <button class="btn btn-outline-primary rounded-circle guest-picker-btn" type="button"
                        (click)="incrementGuests('children', 1)">
                        <i class="fa-solid fa-plus"></i>
                    </button>
                </div>
            </div>
            <div class="tol-divider"></div>
            <div class="guest-picker-row">
                <div class="guest-picker-info">
                    <span class="badge bg-secondary text-lg">{{ guests.infants }}</span>
                    <span>Infants</span>
                </div>
                <div class="guest-picker-actions">
                    <button class="btn btn-outline-primary rounded-circle guest-picker-btn" type="button"
                        (click)="incrementGuests('infants', -1)">
                        <i class="fa-solid fa-minus"></i>
                    </button>
                    <button class="btn btn-outline-primary rounded-circle guest-picker-btn" type="button"
                        (click)="incrementGuests('infants', 1)">
                        <i class="fa-solid fa-plus"></i>
                    </button>
                </div>
            </div>
            <div class="tol-divider"></div>
        </div>
        <div class="d-grid gap-2">
            <button class="btn btn-primary mt-4" type="button" (click)="close()">Update</button>
        </div>
    </div>
</div>



<!-- EO GUESTS-->